import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {Subscription} from 'rxjs';
import {ResultDto} from '../shared/dto/result-dto';
import {CertificateService} from '../shared/services/certificate.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {

  subscription: Subscription;
  token: string;
  hash: string;
  result: ResultDto;

  constructor(
    private spinnerService: NgxSpinnerService,
    private route: ActivatedRoute,
    private certificationService: CertificateService) {
  }

  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.hash = params.hash;
      this.certificationService.getResults(this.token, this.hash);
      this.spinnerService.show();
    });

    this.subscription.add(this.certificationService.resultLoaded.subscribe(result => {
      this.result = result;
      this.spinnerService.hide();
    }));
  }
}
